const cache = { key: null, html: null };

class CartDrawerRecommendations extends HTMLElement {
  connectedCallback() {
    this._render();
  }

  async _render() {
    const token = (this._token = Symbol());
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const sectionId = this.getAttribute('section-id');
    const productId = this.getAttribute('product-id');
    const intent = this.getAttribute('intent') || 'related';
    const limit = Math.min(parseInt(this.getAttribute('limit'), 10) || 10, 10);

    if (!sectionId || !productId) {
      return;
    }

    const key = `${sectionId}|${productId}|${intent}|${limit}`;

    let html = cache.key === key ? cache.html : null;

    if (html === null) {
      html = await fetch(
        `${root}recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`,
        { priority: 'low' }
      )
        .then((response) => (response.ok ? response.text() : ''))
        .catch(() => '');

      if (html) {
        cache.key = key;
        cache.html = html;
      }
    }

    if (this._token !== token || !this.isConnected) {
      return;
    }

    const cards = [
      ...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('.horizontal-product'),
    ].slice(0, limit);

    if (cards.length === 0) {
      return;
    }

    const inner = this.firstElementChild;

    if (!inner || !inner.querySelector('.horizontal-product-list')) {
      return;
    }

    const fresh = inner.cloneNode(true);

    fresh.querySelectorAll('quick-buy-drawer').forEach((drawer) => drawer._delegate?.off());
    fresh.querySelector('.horizontal-product-list').replaceChildren(...cards);

    const controls = fresh.querySelector('[data-carousel-controls]');
    if (controls) controls.style.display = cards.length < 2 ? 'none' : '';

    const prevButton = fresh.querySelector('[is="prev-button"]');
    const nextButton = fresh.querySelector('[is="next-button"]');
    if (prevButton) prevButton.disabled = true;
    if (nextButton) nextButton.disabled = cards.length < 2;

    this.style.display = '';
    inner.replaceWith(fresh);
  }
}

if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);
}
